import { View, TouchableOpacity, TextStyle, ViewStyle } from "react-native";
import TextPrimary from "../text/TextPrimary";

interface TextLinkProps {
  label: string;
  onPress: () => void;
  textStyle?: TextStyle;
  viewStyle?: ViewStyle;
}

const TextLink = (props: TextLinkProps) => {
  return (
    <View style={props.viewStyle}>
      <TouchableOpacity onPress={props.onPress}>
        <TextPrimary label={props.label} textStyle={props.textStyle} />
      </TouchableOpacity>
    </View>
  );
};

export default TextLink;
